import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Formik, Form as FormikForm } from "formik";
import CustomAutoComplete from "../../../../../components/formik/CustomAutoComplete";
import CustomAutoCompleteCustomerSR from "../../../../../components/formik/CustomAutoCompleteCustomerSR";
import moment from "moment-timezone";
import "moment/locale/es";
import TableConceptsInvoice from "../invoice/tableConceptsInvoice";
import InvoiceFormFields from "../invoice/invoiceFormFields";
import Button from "react-bootstrap/Button";
import {
  findFiscalRegimesByCoincidence,
  findCFDIByCoincidence,
  findPaymentFormByCoincidence,
  getFoliosBySocialReason,
  getSeriesBySocialReason,
  findCustomerSocialReasonByCoincidence,
  findPaymentMethodByCoincidence,
  getMySocialReasons,
  createStamp,
  generateInvoice,
} from "../../../../../services/CatalogService";
import Loader from "../../../../../components/loader/index.js";
import axiosClient from "../../../../../config/axios";
import Swal from "sweetalert2";
import { getInvoiceSchema } from "./invoiceSchema.js";
import { XMLParser } from "fast-xml-parser";
import NewCustomer from "../invoice/newCustomer.js";
// import JSZip from "jszip";
import axios from "axios";

const AddInvoiceForm = ({ closeModal, idOrden, razonSocial, onSaved}) => {
  //const razonSocial = "VaroExpress";

  const [fiscalRegimeId, setFiscalRegimeId] = useState(null);
  const [cfdiId, setCfdiId] = useState(null);
  const [paymentFormId, setPaymentFormId] = useState(null);
  const [paymentMethodId, setPaymentMethodId] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [selectedProductKey, setSelectedProductKey] = useState(null);
  const [errors, setErrors] = useState({});
  const [fecha, setFecha] = useState("");
  const [folioSeleccionado, setFolioSeleccionado] = useState("");
  const [folios, setFolios] = useState([]);
  const [serieSeleccionada, setSerieSeleccionada] = useState("");
  const [series, setSeries] = useState([]);
  const [orden, setOrden] = useState(null); // Aquí se guarda la orden vial
  const [lugarExpedicion, setLugarExpedicion] = useState("");
  const [loading, setLoading] = useState(true);
  const [conceptoFactura, setconceptoFactura] = useState("");

  const formikRef = useRef();
  const [showInvoiceForm, setShowInvoiceForm] = useState(true);
  const [showNewCustomerForm, setShowNewCustomerForm] = useState(false);

  const handleNewCustomerClick = () => {
    setShowInvoiceForm(false);
    setShowNewCustomerForm(true);
  };

  const handleAutoCompleteChange = (field, value) => {
    if (field === "fiscalRegimeId") {
      setFiscalRegimeId(value);
    } else if (field === "cfdiId") {
      setCfdiId(value);
    } else if (field === "paymentFormId") {
      setPaymentFormId(value);
    } else if (field === "paymentMethodId") {
      setPaymentMethodId(value);
    }
  };

  useEffect(() => {
    async function initializeForm() {
      try {
        setLoading(true);

        const localDate = moment.tz("America/Mexico_City").format("YYYY-MM-DD");
        setFecha(localDate);
        formikRef.current?.setFieldValue("fecha", localDate);

        // Cargar folios
        const foliosData = await getFoliosBySocialReason(razonSocial);
        setFolios(foliosData || []);

        // Cargar series
        const seriesData = await getSeriesBySocialReason(razonSocial);
        setSeries(seriesData || []);

        // Cargar datos de razón social
        const razonSocialData = await getMySocialReasons(razonSocial);
        if (razonSocialData && razonSocialData.postalCode) {
          setLugarExpedicion(razonSocialData.postalCode);
        } else {
          console.warn("No se encontró el código postal para la razón social");
        }

        let tipoPagoDetectado = ""; // Inicializamos el tipo

        // Cargar orden vial si existe idOrden
        if (idOrden) {
          const { data: ordenData } = await axiosClient.get(
            `/order-vial/${idOrden}`
          );
          setOrden(ordenData);

          // Actualiza conceptoFactura
          if (ordenData?.tipoServicio) {
            setconceptoFactura(
              "Factura por " + ordenData.typeService.type_service_name
            );
          }

          // Cargar método y forma de pago SAT
          const { data: contadoData } = await axiosClient.get(
            `/paymentsOrderVial/byOrderVial/${idOrden}?only_active_payments=true&payment_type_code=CONTADO`
          );

          if (contadoData.count > 0 && contadoData.rows.length > 0) {
            tipoPagoDetectado = "Contado";
            const row = contadoData.rows[0];

            if (row.metodoPagoSAT) {
                const [metodoPago] = await findPaymentFormByCoincidence(
                row.metodoPagoSAT
              );
              if (metodoPago) {
                setPaymentFormId(metodoPago);
                formikRef.current?.setFieldValue("paymentFormId", metodoPago);
              }
            }

            if (row.PaymentMethod?.id_SAT) {
              const [formaPago] = await  findPaymentMethodByCoincidence(
                row.PaymentMethod.id_SAT
              );
              if (formaPago) {
                setPaymentMethodId(formaPago);
                formikRef.current?.setFieldValue("paymentMethodId", formaPago);
              }
            }
          } else {
            // Si no hubo CONTADO, busca CREDITO
            const { data: creditoData } = await axiosClient.get(
              `/paymentsOrderVial/byOrderVial/${idOrden}?only_active_payments=true&payment_type_code=CREDITO`
            );

            if (creditoData.count > 0 && creditoData.rows.length > 0) {
              tipoPagoDetectado = "Credito";
              const row = creditoData.rows[0];

              if (row.metodoPagoSAT) {
                const [metodoPago] = await findPaymentFormByCoincidence(
                  row.metodoPagoSAT
                );
                if (metodoPago) {
                  setPaymentFormId(metodoPago);
                  formikRef.current?.setFieldValue(
                    "paymentFormId",
                    metodoPago
                  );
                }
              }

              if (row.PaymentMethod?.id_SAT) {
                const [formaPago] = await findPaymentMethodByCoincidence(
                  row.PaymentMethod.id_SAT
                );
                if (formaPago) {
                  setPaymentMethodId(formaPago);
                  formikRef.current?.setFieldValue("paymentMethodId", formaPago);
                }
              }
            }
          }
        }

        // Si detectamos tipo de pago, buscar folio y serie por tipo
        if (tipoPagoDetectado) {
          const folioDefault = (foliosData || []).find(
            (f) => f.type === tipoPagoDetectado
          );
          const serieDefault = (seriesData || []).find(
            (s) => s.type === tipoPagoDetectado
          );

          setTimeout(() => {
            if (folioDefault) {
              setFolioSeleccionado(folioDefault.prefix);
              formikRef.current?.setFieldValue("folio", folioDefault.prefix);
            }
            if (serieDefault) {
              setSerieSeleccionada(serieDefault.prefix);
              formikRef.current?.setFieldValue("serie", serieDefault.prefix);
            }
          }, 0); // Esto asegura que Formik ya se haya montado visualmente
        }
      } catch (error) {
        console.error("Error en la inicialización del formulario:", error);
        Swal.fire(
          "Error",
          "Hubo un problema al cargar la información inicial",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }

    initializeForm();
  }, [idOrden, razonSocial]);

  useEffect(() => {
    const setCfdiAndRegime = async () => {
      if (customerId && customerId.cfdi && customerId.fiscalRegime) {
        try {
          // Buscar CFDI por ID
          const cfdiResults = await findCFDIByCoincidence(customerId.cfdi.id);
          if (cfdiResults?.length) {
            setCfdiId(cfdiResults[0]);
            formikRef.current?.setFieldValue("cfdiId", cfdiResults[0], true);
          } else {
            setCfdiId(null);
            formikRef.current?.setFieldValue("cfdiId", null, true);
          }

          // Buscar Régimen Fiscal por ID
          const regimeResults = await findFiscalRegimesByCoincidence(
            customerId.fiscalRegime.id
          );
          if (regimeResults?.length) {
            setFiscalRegimeId(regimeResults[0]);
            formikRef.current?.setFieldValue(
              "fiscalRegimeId",
              regimeResults[0],
              true
            );
          } else {
            setFiscalRegimeId(null);
            formikRef.current?.setFieldValue("fiscalRegimeId", null, true);
          }
        } catch (error) {
          console.error("Error buscando cfdi/regimen:", error);
          setCfdiId(null);
          setFiscalRegimeId(null);
          formikRef.current?.setFieldValue("cfdiId", null, true);
          formikRef.current?.setFieldValue("fiscalRegimeId", null, true);
        }
      } else {
        setCfdiId(null);
        setFiscalRegimeId(null);
        formikRef.current?.setFieldValue("cfdiId", null, true);
        formikRef.current?.setFieldValue("fiscalRegimeId", null, true);
      }
    };

    setCfdiAndRegime();
  }, [customerId]);

  if (loading) {
    return <Loader isLoading={true} />;
  }

  return (
  <>
    {showInvoiceForm && (

    <Formik
      innerRef={formikRef}
      initialValues={{
        conceptoFactura: conceptoFactura,
        fecha: fecha,
        folio: folioSeleccionado,
        serie: serieSeleccionada,
        cfdiId: cfdiId,
        fiscalRegimeId: fiscalRegimeId,
        paymentFormId: paymentFormId,
        paymentMethodId: paymentMethodId,
        customerId: customerId,
        conceptosFacturaTabla: [],
      }}
      initialTouched={{
        conceptoFactura: true,
        fecha: true,
        folio: true,
        serie: true,
      }}
      enableReinitialize={false}
      validationSchema={getInvoiceSchema()}
      onSubmit={async (values, { setSubmitting }) => {
        //console.log(values);
        console.log('Valor actual de customerId:', customerId);
        //console.log('fecha', values.fecha);

        const confirmResult = await Swal.fire({
          title: "¿Estás seguro?",
          text: "¿Deseas facturar esta orden?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, facturar",
          cancelButtonText: "Cancelar",
        });

        if (!confirmResult.isConfirmed) {
          setSubmitting(false);
          return;
        }

        try {
          // Construcción del objeto para el timbrado
          const stampData = {
            Version: "4.0",
            Moneda: "MXN",
            Fecha: fecha + "T00:00:00",
            Serie: values.serie,
            Folio: values.folio,
            TipoDeComprobante: "I",
            Exportacion: "01",
            FormaPago: values.paymentMethodId?.id || "",
            MetodoPago: values.paymentFormId?.id || "",
            LugarExpedicion: lugarExpedicion || "00000",
            Receptor: {
              Rfc: customerId?.rfc || "",
              Nombre: customerId?.name || "",
              DomicilioFiscalReceptor: customerId?.postalCode || "",
              RegimenFiscalReceptor: values.fiscalRegimeId?.id || "",
              UsoCFDI: values.cfdiId?.id || "",
            },
            ObjetoImp: "02",
            lada: customerId?.lada_phone,
            phone: customerId?.phone,
            Conceptos: values.conceptosFacturaTabla.map((c) => {
              const precioUnitarioSinIva = parseFloat(c.precioUnitario) || 0;
              const cantidad = parseFloat(c.cantidad) || 0;
          
              // Convertimos a CON IVA
              const valorUnitarioConIva = precioUnitarioSinIva * 1.16;
              const importeConIva = valorUnitarioConIva * cantidad;
          
              return {
                ClaveProdServ: c.productKey?.idKey || "",
                Cantidad: cantidad.toString(),
                ClaveUnidad: c.unitKey?.idKey || "",
                Unidad: "Servicio",
                Descripcion: conceptoFactura,
          
                // Valores correctos para timbrado
                ValorUnitario: valorUnitarioConIva.toFixed(2),
                Importe: importeConIva.toFixed(2),
          
                // Retención
                needRetention: c.needRetention,
          
                Descuento: "0.00",
                ObjetoImp: "02",
              };
            }),
          };
          console.log("Stamp enviados: ", stampData);

          const data = await createStamp(stampData, razonSocial);
          console.log("Stamp result data: a", data);

          // Función para limpiar
          const cleanNumber = (value) => {
            if (!value) return 0;
            const cleaned = value.toString().replace(/[^0-9.-]+/g, "");
            return cleaned === "" ? 0 : Number(cleaned);
          };

          // Parsear XML del cfdi
          const parser = new XMLParser({
            ignoreAttributes: false,
            attributeNamePrefix: "@_",
          });

          const cfdiXml = data.cfdi.cfdi;
          const cfdiParsed = parser.parse(cfdiXml);

          // El comprobante viene en cfdi:Comprobante
          const comprobante = cfdiParsed["cfdi:Comprobante"];

          // Extraer subtotal y total desde atributos
          const cleanSubtotal = cleanNumber(comprobante["@_SubTotal"]);
          const cleanTotal = cleanNumber(comprobante["@_Total"]);

          // Extraer impuestos
          const impuestos = comprobante["cfdi:Impuestos"] || {};
          const traslados = impuestos["cfdi:Traslados"]?.["cfdi:Traslado"];
          const trasladoIVA = Array.isArray(traslados)
            ? traslados[0]
            : traslados || {};

          // IVA total
          const cleanIva = cleanNumber(
            impuestos["@_TotalImpuestosTrasladados"] ||
              trasladoIVA["@_Importe"] ||
              0
          );

          const retencion = cleanNumber(
            impuestos["@_TotalImpuestosRetenidos"] || 0
          );

          if (data?.cfdi?.uuid) {
            const stampedInvoicePayload = {
              customer_name: stampData.Receptor.Nombre,
              customer_rfc: stampData.Receptor.Rfc,
              issued_at: moment.utc().format(),
              orderVialId: idOrden,
              id_facturacion_stamp: data.id,
              uuid_stamp: data.cfdi.uuid,
              status: data.cfdi.status || "vigente",

              total: cleanTotal,
              subtotal: cleanSubtotal,
              iva: cleanIva,
              retencion: retencion,
            };
            console.log("datos guardados factura", stampedInvoicePayload);

            await axiosClient.post(
              "/stamped-invoice/save",
              stampedInvoicePayload
            );
          }

          // Notificar al padre que se guardó
          if (onSaved) {
            onSaved();
          }

          Swal.fire({
            title: "¡Éxito!",
            text: "La orden ha sido facturada correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
          });

          //closeModal();
        } catch (err) {
        const errorData = err.response?.data;
        const errorMessage = Array.isArray(errorData?.message)
          ? errorData.message.join(", ")
          : errorData?.message || errorData?.error || "Ha ocurrido un error inesperado";


          Swal.fire({
            title: "Ups!",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Cerrar",
            showCancelButton: false,
          });
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {(formik) => {
        const { values, handleChange, touched, errors, isSubmitting } = formik;

        return (
          <>
            <Loader isLoading={isSubmitting} />
            <FormikForm noValidate>
              <InvoiceFormFields
                formik={formik}
                conceptoFactura={conceptoFactura}
                setconceptoFactura={setconceptoFactura}
                fecha={fecha}
                setFecha={setFecha}
                folios={folios}
                folioSeleccionado={folioSeleccionado}
                setFolioSeleccionado={setFolioSeleccionado}
                series={series}
                serieSeleccionada={serieSeleccionada}
                setSerieSeleccionada={setSerieSeleccionada}
                paymentFormId={paymentFormId}
                paymentMethodId={paymentMethodId}
                cfdiId={cfdiId}
                fiscalRegimeId={fiscalRegimeId}
                customerId={customerId}
                setCustomerId={setCustomerId}
                handleAutoCompleteChange={handleAutoCompleteChange}
                findPaymentFormByCoincidence={findPaymentFormByCoincidence}
                findPaymentMethodByCoincidence={findPaymentMethodByCoincidence}
                findCustomerSocialReasonByCoincidence={
                  findCustomerSocialReasonByCoincidence
                }
                findCFDIByCoincidence={findCFDIByCoincidence}
                findFiscalRegimesByCoincidence={findFiscalRegimesByCoincidence}
                razonSocial={razonSocial}
                errors={formik.errors}
                touched={formik.touched}
                handleChange={formik.handleChange}
                values={formik.values}
                onNewCustomerClick={handleNewCustomerClick}
              />
              <Row className="mb-2">
                <Col>
                  <br></br>
                  <h5 className="border-bottom pb-2">Conceptos</h5>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <TableConceptsInvoice
                    values={values}
                    handleChange={handleChange}
                    errors={errors}
                    touched={touched}
                    selectedProductKey={selectedProductKey}
                    setSelectedProductKey={setSelectedProductKey}
                    orden={orden}
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-end mt-4">
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  className="btn btn-primary mt-3 me-2"
                >
                  {isSubmitting ? "Guardando..." : "Guardar cambios"}
                </Button>

                <button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-info mt-3"
                >
                  Cerrar
                </button>
              </div>
            </FormikForm>
          </>
        );
      }}
    </Formik>
    )}
    
    {showNewCustomerForm && (
        <NewCustomer
          onBack={(newCustomer) => {
            setShowNewCustomerForm(false);
            setShowInvoiceForm(true);

            if (newCustomer) {
              setCustomerId(newCustomer);
              if (formikRef.current) {
                formikRef.current.setFieldValue("customerId", newCustomer);
              }
            }
          }}
        />
      )}
  </>
  );
};

export default AddInvoiceForm;
